import React from 'react'

import { User } from '@/lib/types/UserT'
import { cn } from '@/lib/utils'
import { FOCUS_RING } from '@/components/livecontact/fieldStyles'
import UserTag from '@/components/UserSelectField/Tag'

type Props = {
  selectedUsers: User[]
  inputValue: string
  onFocus?: () => void
  onBlur?: () => void
  onInputChange: (val: string) => void
  onRemoveUser: (id: number) => void
  onKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void
  inputRef: React.RefObject<HTMLInputElement>
  placeholder: string
  isMultiple: boolean
}

/** Chip + search input on the field surface. */
const UserSelectInput = ({
  selectedUsers,
  inputValue,
  onInputChange,
  onRemoveUser,
  onKeyDown,
  onFocus,
  onBlur,
  inputRef,
  placeholder,
  isMultiple,
}: Props) => (
  <div
    className={cn(
      'flex min-h-8 w-full cursor-text flex-wrap items-center gap-1 rounded-[8px] bg-surface px-1.5 py-1 shadow-input transition-shadow duration-[160ms] ease-out-strong',
      `focus-within:shadow-[${FOCUS_RING}]`
    )}
    onClick={() => inputRef.current?.focus()}
  >
    {selectedUsers.map((user) => (
      <UserTag key={user.id} user={user} onRemove={onRemoveUser} />
    ))}
    {(selectedUsers.length === 0 || isMultiple) && (
      <input
        ref={inputRef}
        type="text"
        value={inputValue}
        onChange={(e) => onInputChange(e.target.value)}
        onFocus={onFocus}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
        placeholder={placeholder}
        className="h-6 min-w-[80px] flex-1 bg-transparent px-1 text-[14px] leading-[1.4] tracking-[-0.2px] text-ink outline-none placeholder:text-ink-4"
      />
    )}
  </div>
)

export default UserSelectInput
